<template>
  <v-card>
    <v-card-title>
      <h2 class="modal-title">{{ 'activities.add_country' | translate }}</h2>
    </v-card-title>
    <v-card-content>
      <div class="form-element">
        <v-input-r :label="$t('activities.choose')" :hint="errorMessage('name')" :invalid="!!errorMessage('name')"
          v-model="form.name" />
      </div>
      <div class="form-element">
        <v-select-r :label="$t('history.timezone')" :hint="errorMessage('timezone_name')"
          :invalid="!!errorMessage('timezone_name')" v-model="form.timezone_name" :options="options.timezones"
          itemValue="value" />
      </div>
      <div>
        <v-file-input :hint="errorMessage('logo')" :invalid="!!errorMessage('logo')" :placeholder="$t('activities.choose')"
          v-model="form.logo" accept="image/*" />
      </div>
    </v-card-content>
    <v-card-actions>
      <v-btn :disabled="loading || !isValid" :loading="loading" type="submit" @click="onCreate">
        {{ $t('base.add') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import api from '@/api'
import formErrorsMixin from '@/mixins/form-errors.mixin.js'

export default {
  name: 'AddCountryModal',

  data: () => ({
    form: {
      name: null,
      timezone_name: null,
      logo: null
    },
    options: {
      timezones: []
    },
    errors: {
      name: null,
      timezone_name: null,
      logo: null
    },
    loading: false
  }),

  mixins: [formErrorsMixin],

  computed: {
    lang () {
      return this.$store.getters['account/lang']
    },
    isValid () {
      return this.form.name && this.form.timezone_name
    }
  },

  async mounted () {
    this.loadOptions()
  },

  methods: {
    async onCreate () {
      if (this.loading) return
      this.loading = true

      this.checkValidData()

      if (this.errors.name || this.errors.timezone_name || this.errors.logo) {
        this.loading = false
        return
      }

      const formData = new FormData()
      formData.append('name', this.form.name)
      formData.append('timezone_name', this.form.timezone_name)
      formData.append('logo', this.form.logo || '')
      this.$emit('submit', formData)
      this.$emit('close')

      this.loading = false
    },

    checkValidData () {
      this.errors.name = null
      this.errors.timezone_name = null
      this.errors.logo = null

      if (!this.form.name) {
        this.errors.name = ['3']
      } else if (this.form.name.length > 100) {
        this.errors.name = ['6', 100]
      }

      if (!this.form.timezone_name) {
        this.errors.timezone_name = ['3']
      }

      if (this.form.logo) {
        const maxSize = 5 * 1024 * 1024
        if (this.form.logo.size > maxSize) {
          this.errors.logo = ['7']
        }

        const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp']
        if (!allowedTypes.includes(this.form.logo.type)) {
          this.errors.logo = ['8']
        }
      }
    },

    async loadOptions () {
      try {
        const { data } = await api.local.timezones()
        this.options.timezones = Object
          .entries(data)
          .filter((item) => {
            if (this.lang === 'us') {
              return item[0].includes('America')
            } else return true
          })
          .map(item => ({
            name: `(${item[1]}) ${item[0]}`,
            value: item[0]
          }))
      } catch (error) {
        console.error('Помилка завантаження часових зон:', error)
      }
    }
  }
}
</script>

<style scoped>
.v-card__title {
  padding: 2rem 2.4rem 1.6rem;
}

.modal-title {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
}

.v-card__content {
  border-top: .1rem solid #d7d7d7;
  padding-bottom: 1.5rem !important;
}

.form-element {
  margin-bottom: 3rem;
}

.v-card__actions {
  padding: 0 2.4rem 2.4rem;
}

.v-card__actions button {
  width: 100%;
}
</style>
